import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import api from "../../services/api.js";
import config from "../../pwaConfig.json";
import { getUserProfileData } from "../../services/dataServices/userProfileService";
import score from "../../assets/images/coin-diamond.png";
import profile1 from "../../assets/images/profile/pro-1.png";
import profile2 from "../../assets/images/profile/pro-2.png";
import profile3 from "../../assets/images/profile/pro-3.png";
import profile4 from "../../assets/images/profile/pro-4.png";
import profile5 from "../../assets/images/profile/pro-5.png";
import profile6 from "../../assets/images/profile/pro-6.png";
import profile7 from "../../assets/images/profile/pro-7.png";
import profile8 from "../../assets/images/profile/pro-8.png";
import { showWarningMessage } from "services/utility";
import Body from "elements/Body.js";

function importAll(r) {
  return r.keys().map(r);
}

const profileImages = importAll(
  require.context("./", false, /\.(png|jpe?g|svg)$/)
);

const defaultProps = {
  initialPage: 1,
};

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };
  }

  componentWillMount() {
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage);
    }
  }

  setPage(page) {
    var items = this.props.items;
    var pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    pager = this.getPager(items.length, page);

    var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
    this.setState({ pager: pager });
    this.props.onChangePage(pageOfItems);
  }

  getPager(totalItems, currentPage, pageSize) {
    currentPage = currentPage || 1;

    pageSize = pageSize || 10;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= 4) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 4;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 3;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  render() {
    var pager = this.state.pager;

    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }

    return (
      <div className="row p-0 mb-3 m-auto">
        <div className="col-md-12 pt-2">
          <div aria-label="Page navigation example text-right text-center ">
            <ul className="pagination justify-content-center">
              <li
                className={
                  pager.currentPage === 1 ? "disabled page-item" : "page-item"
                }
              >
                <a
                  className="page-link"
                  // href="#"
                  onClick={() => this.setPage(pager.currentPage - 1)}
                >
                  <i className="icon-back-arrow" />
                </a>
              </li>
              {pager.pages.map((page, index) => (
                <li
                  key={index}
                  className={
                    pager.currentPage === page
                      ? "active page-item"
                      : "page-item"
                  }
                >
                  <a
                    className="page-link"
                    // href="#"
                    onClick={() => this.setPage(page)}
                  >
                    {page}
                  </a>
                </li>
              ))}

              <li
                className={
                  pager.currentPage === pager.totalPages
                    ? "disabled page-item"
                    : "page-item"
                }
              >
                <a
                  className="page-link"
                  // href="#"
                  onClick={() => this.setPage(pager.currentPage + 1)}
                >
                  <i className="icon-next" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

Pagination.defaultProps = defaultProps;

class LeaderBoard extends Component {
  state = {
    exampleItems: null,
    spinner: true,
    pageOfItems: [],
    profile: {
      first_name: "",
      last_name: "",
      user_email: "",
      board_name: "",
      lang_pref: "",
      grade_name: "",
      school_id: "",
      id: "",
    },
  };

  constructor() {
    super();
    this.onChangePage = this.onChangePage.bind(this);
  }

  async componentDidMount() {
    let userData = await getUserProfileData();
    if (userData) {
      await this.getLeaderBoard(userData);
      this.setState({
        profile: { ...userData },
        // spinner: false,
      });
    }
  }

  getLeaderBoard = async (userData) => {
    // console.log("User Profile data", this.state.profile);
    const inputData = {
      board_id: userData.board_name,
      grade_id: userData.grade_name,
      numberOfRecords: 100,
      school_id: userData.school_id,
      user_id: userData.id,

      // board_id: "CBSE",
      // grade_id: "10",
      // numberOfRecords: 50,
      // school_id: "1",
      // user_id: 2500509,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      api
        .post(`${config.apiEndPoint}/leaderboardpwa`, inputData, {
          headers: headers,
        })
        .then((response) => {
          var leaderBoardData = response;
          if (leaderBoardData.status == 404) {
            this.setState({
              userScore: 0,
              userRank: 0,
              spinner: false,
            });
            // alert("No data available for Leader Board");
            showWarningMessage("No data available for Leader Board", 1);
          } else {
            this.setState({
              userScore: leaderBoardData.final.userRank.score,
              userRank: leaderBoardData.final.userRank.rank,
              userAvatar: leaderBoardData.final.userRank.avatar,
              exampleItems: leaderBoardData.final.allRank,
              spinner: false,
            });
          }
        });
    } catch (error) {
      console.error(error);
      showWarningMessage("No leader data available", 1);
    }
    // const { data: leaderBoardData } = await api.post(
    //   `${config.apiEndPoint}/leaderboardpwa`,
    //   inputData,
    //   {
    //     headers: headers,
    //   }
    // );x
    // if (leaderBoardData !== null) {

    // } else {
    //   // alert("No leader data available");
    //   showWarningMessage("No leader data available", 1);
    // }
  };

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  getProfileImages(name) {
    switch (name) {
      case "Scientist":
        return profile1;
      case "Engineer":
        return profile2;
      case "Doctor":
        return profile3;
      default:
        return profile4;
    }
  }

  render() {
    return (
      <Body
        loading={this.state.spinner}
        component={
          <div id="CommonPageHolder">
            <div className="container">
              <div className="row no-gutters p-0">
                <div className="col-md-12 p-0 m-0">
                  <div className="col-sm-12 mx-auto text-center my-auto top-leaderboard-img">
                    {" "}
                  </div>
                  {/* {!this.state.spinner ? ( */}
                  <div className="width-100 mx-auto  my-auto LeaderboardCard">
                    <div className="page-header"> Leaderboard</div>
                    <div className="row no-gutters p-0 mb-3 mx-0">
                      <div className="col-md-12 m-auto head-leaderboard ">
                        <div className="width-100 px-0 pb-2 m-0 text-center">
                          <div className="width-100  leaderboard-name text-orange  ">
                            {this.state.profile.first_name}
                          </div>
                          <div className="width-100  leaderboard-class">
                            {this.props.t("leader_board_page.class")}{" "}
                            {this.state.profile.grade_name},{" "}
                            {this.state.profile.board_name}
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12  m-auto">
                          <div className="row no-gutters">
                            <div
                              className="m-auto text-center width-50"
                              style={{ borderRight: "1px dotted #000" }}
                            >
                              <div className="row no-gutters width-100 d-f-c">
                                <div className="width-30 text-center ">
                                  {" "}
                                  <img
                                    src={this.getProfileImages(
                                      this.state.userAvatar
                                    )}
                                    width="60px"
                                    className="img-fluid img-circle"
                                  />{" "}
                                </div>
                                <div className="width-auto text-center mx-2">
                                  <div className="width-100   px-2 py-0 leaderboard-small-title text-center m-auto">
                                    {this.props.t(
                                      "leader_board_page.your_rank"
                                    )}
                                  </div>
                                  <div className=" leaderboard-rank-main text-orange text-center m-auto ">
                                    {this.state.userRank == 0 ||
                                    this.state.userScore == 0
                                      ? "NA"
                                      : Math.round(this.state.userRank)}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="width-50">
                              <div className="row no-gutters width-100 d-f-c">
                                <div className="width-30 text-center ">
                                  {" "}
                                  <img
                                    src={score}
                                    width="60px"
                                    className="img-fluid "
                                  />{" "}
                                </div>
                                <div className="width-auto p-0  text-left">
                                  <div className="width-100  pt-2 px-2 py-0 leaderboard-small-title text-center m-auto">
                                    {this.props.t(
                                      "leader_board_page.you_earned"
                                    )}
                                  </div>
                                  <div className="width-auto  leaderboard-score-main text-orange text-center m-auto">
                                    {Math.round(this.state.userScore)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row no-gutters mt-2 d-flex justify-content-center">
                      <div className="leaderboard-item-flex-title">
                        <div className="width-20 float-left text-center leader-num-text">
                          {/* <span class="lblable"> Rank </span> */}
                          <span className="lblable">Rank</span>
                        </div>
                        <div className="width-80 text-right leader-name">
                          <span className="lblable lbscore text-right">
                            {" "}
                            Knowledge wealth
                          </span>
                        </div>
                      </div>

                      <div className="leaderboard-item-flex-title d-none d-lg-flex">
                        <div className="width-10 float-left text-center leader-num-text">
                          {/* <span class="lblable"> Rank </span> */}
                          <span className="lblable">Rank</span>
                        </div>
                        <div className="width-90 text-right leader-name">
                          <span className="lblable lbscore text-right">
                            {" "}
                            Knowledge wealth
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="width-100 content-leaderboard">
                      <div className="row d-flex justify-content-center">
                        {this.state.pageOfItems.map((item, i) => (
                          <div
                            key={i}
                            className="leaderboard-item-flex shadow-sm"
                          >
                            <div className="width-auto float-left text-center leader-num">
                              {/* <span class="lblable"> Rank </span> */}
                              <span className="lbrank">{item.rank}</span>
                            </div>
                            <div className="width-15 float-left mt-1 text-center">
                              {" "}
                              <img
                                src={this.getProfileImages(item.avatar)}
                                width="30px"
                                height="30px"
                                className="img-fluid img-circle"
                              />
                            </div>
                            <div className="width-75 float-left leader-name">
                              <div className="row no-gutters d-flex align-items-center">
                                <div className="col-md-10 col-sm-12  align-items-center width-75 float-right leader-name text-left">
                                  {item.fullname}
                                </div>

                                <div className="col-md-2  align-items-center  width-25 float-right leader-score text-right">
                                  {/* <span class="lblable">You  </span> */}
                                  <span className="lbscore"> {item.score}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <Pagination
                      items={this.state.exampleItems}
                      onChangePage={this.onChangePage}
                    />
                  </div>
                  {/* ) : (
              <div className="col-sm-10  mx-auto  my-auto text-center width-100 spinner-center">
                <Spinner
                  className="spinner-center"
                  animation="border"
                  style={{ color: "#1b1f5f" }}
                  size="lg"
                />
              </div>
            )} */}
                </div>
              </div>
            </div>
          </div>
        }
      />
    );
  }
}

export default withRouter(withTranslation()(LeaderBoard));
